"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components")); // todo width + fix for signup/signin


var FormFieldContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    margin-bottom: 14px;\n    width: ", ";\n    flex-direction: column;\n    align-items: flex-start;\n"], ["\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    margin-bottom: 14px;\n    width: ", ";\n    flex-direction: column;\n    align-items: flex-start;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? '100%' : '350px';
});
exports.default = responsive_1.withResponsiveMeta(FormFieldContainer);
var templateObject_1;